<template>
  <div>
    <list
      ref="list"
      unit="收发存汇总表"
      row-key="Id"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.GetSummaryList"
      @row-select="onClickRow"
      @reset-query="$emit('reset-select')"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="单据日期">
          <range-picker
            :date="[params.DocDateStart, params.DocDateEnd]"
            @change="x=>{params.DocDateStart=x.Start;params.DocDateEnd=x.End;}"
          />
        </el-form-item>
        <el-form-item label="商品名称">
          <goodsModule  @restaurants='setGoods' :state='params.GoodsName'/>
          <!-- <el-input v-model="params.GoodsId" placeholder="请选择商品名称'" @focus="addGoods" readonly></el-input> -->
        </el-form-item>
        <el-form-item label="仓库名称">
          <el-select
            size="mini"
            v-model="params.WarehouseId"
            placeholder="请选择"
            @change="onSelWarehouse"
            clearable
          >
          <el-option
            v-for="item in wareList"
            :key="item.WarehouseId" 
            :label="item.WarehouseName" 
            :value="item.WarehouseId"
            >
          </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区分仓库">
          <el-select
            size="mini"
            v-model="params.IsWarehouse"
            placeholder="请选择"
            @change="onSelWarehouse"
          >
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="WarehouseCode" label="仓库编码"  sortable align="center"  width="120px"/>
        <el-table-column prop="WarehouseName" label="仓库名称" sortable align="center"  width="120px"/>
        <el-table-column prop="GoodsCode" label="商品编码" sortable align="center" width="120px" >
          <template slot-scope="{row}">
            <a @click.prevent="onClickRow(row)">{{ row.GoodsCode }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="GoodsName" label="商品名称" sortable align="center" width="120px" />
        <el-table-column prop="Model" label="规格型号" align="center" />
        <el-table-column prop="MainUnitName" label="主单位" align="center" />
         <el-table-column prop="UnitName" label="辅单位" align="center" />
        <el-table-column label="期初结存" align="center">
          <el-table-column prop="BeginQuantity" label="主数量"  width="100px" sortable align="center" />
          <el-table-column prop="BeginPrice" label="单价" sortable align="center" />
          <el-table-column prop="BeginAmount" label="金额" sortable align="center" />
        </el-table-column>
        <el-table-column label="本期入库" align="center">
          <el-table-column prop="InQuantity" label="主数量" width="120px" sortable align="center" />
          <el-table-column prop="InPrice" label="单价" sortable align="center" />
          <el-table-column prop="InAmount" label="金额" sortable align="center" />
        </el-table-column>
        <el-table-column label="本期出库" align="center">
          <el-table-column prop="OutQuantity" label="主数量"  width="120px" sortable align="center" />
          <el-table-column prop="OutPrice" label="单价" sortable align="center" />
          <el-table-column prop="OutAmount" label="金额" sortable align="center" />
        </el-table-column>
        <el-table-column label="期末结存" align="center">
          <el-table-column prop="EndQuantity" label="主数量"  width="120px" sortable align="center" />
          <el-table-column prop="EndPrice" label="单价" sortable align="center" />
          <el-table-column prop="EndAmount" label="金额" sortable align="center" />
        </el-table-column>
      </template>
    </list>
     <goods-dialog ref="goodsDialog" in-dialog selectable @select="setGoods" />
  </div>
</template>
<script>
import goodsModule from "@/components/common/goodsModule/goodsModule";
import goodsDialog from "@/components/sales/business/listDialog";
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list,goodsDialog,goodsModule },
  data() {
    return {
      api: require("@/api/stock/costBook").default,
      wareApi: require("@/api/ba/warehouse").default,
      showType: 0,
      showList: 0,
      wareList: [],
      showSum: true,
      params: {
        DocDateStart: "",
        DocDateEnd: "",
        GoodsName: "",
        GoodsId:'',
        WarehouseId:'',
        IsWarehouse: true
      },
      WarehouseName:''
    };
  },
  mounted() {
    this.wareApi.list({ PageIndex: 1, PageSize: 100 }).then(res => {
      this.wareList = res.Data
      sessionStorage.setItem("ware",JSON.stringify(res.Data))
    })
  },
  methods: {
    setGoods(data) {
      this.params.GoodsId = data.GoodsId;
      this.params.GoodsName = data.GoodsName;
    },
      // setGoods(e) {
      //   this.params.GoodsName=e.GoodsName
      //   this.params.GoodsId=e.GoodsId
      // },
    addGoods() {
      this.$refs.goodsDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    changeName(e) {
      this.$refs.list.query()
    },
    /** 点击行数据 */
    onClickRow(row){
      // 没有填写
      if(!this.params.DocDateStart){
        this.$confirm("追溯单据前需先填写表头中的单据日期才能查询对应的数据，是否继续追溯单据？", "请确认", {
          confirmButtonText: "继续追溯",
          cancelButtonText: "取消追溯",
          type: "warning"}).then(() => {
            this.goToPage(row)
          }).catch(() => {
            
          }
        );
      }else if(!this.params.WarehouseId && !row.WarehouseId){
        this.$confirm("追溯单据前需先填写表头中的仓库才能查询对应的数据，是否继续追溯单据？", "请确认", {
          confirmButtonText: "继续追溯",
          cancelButtonText: "取消追溯",
          type: "warning"}).then(() => {
            this.goToPage(row)
          }).catch(() => {
            
          }
        );
      }else{
        this.goToPage(row)
      }
      
    },
    goToPage(row){
      this.$router.push({
        path: "/stock/cost/detail",
        query: {
          WarehouseId: row.WarehouseId ? row.WarehouseId : this.params.WarehouseId ? this.params.WarehouseId : '',
          WarehouseName:row.WarehouseName ? row.WarehouseName : this.params.WarehouseName ? this.params.WarehouseName : '',
          DocDateStart: this.params.DocDateStart ?? '',
          DocDateEnd: this.params.DocDateEnd ?? '',
          GoodsName: row.GoodsName,
          GoodsId: row.GoodsId
        },
      });
    },
    /** 选中仓库 */
    onSelWarehouse(row){
      console.log(this.wareList);
      console.log(row);
      this.wareList.forEach(item=>{
        if(item.WarehouseId == this.params.WarehouseId){
          this.WarehouseName = item.WarehouseName
        }
      })
      console.log(this.WarehouseName);
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.StSummaryRptExport(this.params).then(() => {
        loading.close();
      });
    },
  },
};
</script>